export enum MouseButton {
    Left = 0,
    Middle = 1,
    Right = 2,
    Fourth = 3,
    Fifth = 4
}
